<template>
  <div class="about-container">
    <img
      class="banner"
      :src="require('@/assets/images/about-banner.png')"
      alt="bg"
    />
    <div class="tabs-container">
      <Tabs
        :tabs="tabItems"
        :activeIndex.sync="currentIndex"
        @update:activeIndex="handleIndexChange"
      />
    </div>
    <div class="tabs-content">
      <transition name="fade" mode="out-in">
        <div v-if="loading" key="loading" class="tab-loading">加载中...</div>
        <div v-else key="content">
          <GlobalTitlte
            v-if="currentIndex === 0"
            style="margin-top: 40px; margin-bottom: 20px"
            En="Company Profile"
            :Zh="$t('about.p1')"
          >
            <template #right>
              <div class="gloabl-title-right">
                {{ $t('about.p2') }}
              </div>
            </template>
          </GlobalTitlte>
          <div class="wangeditor" v-html="content"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Tabs from '@/components/Tabs.vue';
import { getLang } from '@/locale/utils';
import { getPageId } from '@/js/nowRoute';
import GlobalTitlte from '@/components/GlobalTitlte.vue';

const DEFAULT_PID = 47;

export default {
  name: 'About',
  components: {
    Tabs,
    GlobalTitlte,
  },
  data() {
    return {
      tabItems: [],
      currentIndex: 0,
      content: '',
      loading: false,
    };
  },
  mounted: async function () {
    await this.fetchTabs();

    const id = this.tabItems[0].id;
    this.fetchTabContent(id);
  },
  methods: {
    async fetchTabs() {
      const pid = getPageId('about') || DEFAULT_PID;

      const res = await this.$http.get('/common/category/getList', {
        pid,
        lang_code: getLang(),
      });

      if (res.code == 200) {
        this.tabItems = res.data.map((item) => ({
          ...item,
          title: item.category_name,
        }));
      }
    },
    async fetchTabContent(id) {
      this.loading = true;
      const res = await this.$http.get(
        '/api/about/info',
        { category_id: id },
        { headers: { lang: getLang() } }
      );

      if (res.code == 200 && res.data) {
        this.content = res.data.content;
      }
      this.loading = false;
    },
    handleIndexChange(index) {
      const id = this.tabItems[index].id;
      this.fetchTabContent(id);
    },
  },
};
</script>
<style lang="less">
.about-container .tabs-content {
  img,
  video {
    max-width: 100% !important;
  }
}
</style>

<style lang="less" scoped>
.about-container {
  width: 100%;

  .banner {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
    object-fit: cover;
  }
}

.tabs-container {
  margin-bottom: 20px;
  margin-top: 80px;
}

.nav-item {
  margin-right: 20px;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  padding: 5px 0;
}

.nav-item.router-link-active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.contact-info {
  margin-bottom: 20px;
}

.tabs-content {
  margin-top: 20px;
  max-width: 80%;
  margin: 0 auto;
}

.wangeditor {
  min-height: 400px;
}

.bm-view {
  width: 100%;
  height: 500px;
}

.tab-loading {
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 18px;
  background: #fafafa;
  border-radius: 8px;
  transition: background 0.2s;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 1280px) {
  .about-container {
    .banner {
      // max-width: 1000px;
    }
  }
}

@media (max-width: 900px) {
  .about-container {
    .banner {
      height: 400px;
      object-fit: cover;
    }
  }

  .tabs-container {
    margin-bottom: 10px;
    margin-top: 20px;
  }

  .wangeditor {
    min-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue